export default {"src":"/_next/static/media/info.7732c6da.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};